/**
 * Badge visual "Bloqueado" pra indicar cliente bloqueado no tenant.
 * Vermelho pra dar feedback imediato — cliente bloqueado nao consegue
 * abrir novo emprestimo.
 */

import { useTranslation } from "react-i18next";

export function BlockedBadge({ className = "" }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-red-100 px-2 py-0.5 text-[11px] font-medium text-red-800 dark:bg-red-900/40 dark:text-red-200 ${className}`}
      title={t("clients.blocked_badge_title") ?? undefined}
    >
      <LockIcon />
      {t("clients.blocked_badge")}
    </span>
  );
}

function LockIcon() {
  return (
    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <rect x="4" y="11" width="16" height="10" rx="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 11V7a4 4 0 018 0v4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
